export function Dashboard() {
  return (
    <div className="dashboard">
      <h2>Welcome to the M&B Internal API Developer Portal</h2>
      <p className="subtitle">
        Discover, explore, and integrate with our managed API catalog.
      </p>

      <div className="cards">
        <div className="card">
          <h3>API Catalog</h3>
          <p>Browse available APIs with full OpenAPI documentation, try endpoints, and view schemas.</p>
          <a href="/apis">Explore APIs →</a>
        </div>

        <div className="card">
          <h3>API Keys</h3>
          <p>Manage your API keys and view usage statistics against your allocated quota.</p>
          <a href="/keys">Manage Keys →</a>
        </div>

        <div className="card">
          <h3>Getting Started</h3>
          <p>All requests require an API key via the X-Api-Key header.</p>
          <code className="code-block">
            {`curl -H "X-Api-Key: YOUR_KEY" \\
  https://api.meshandbar.com.au/v1/studio/getJobData?xxxxx`}
          </code>
        </div>
      </div>

      <style>{`
        .dashboard h2 { margin-bottom: 0.5rem; }
        .subtitle { color: var(--color-text-muted); margin-bottom: 2rem; }
        .cards { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 1.5rem; }
        .card { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: 8px; padding: 1.5rem; }
        .card h3 { margin-bottom: 0.75rem; }
        .card p { color: var(--color-text-muted); margin-bottom: 1rem; font-size: 0.9rem; }
        .code-block { display: block; background: #1a1a2e; color: #e0e0e0; padding: 1rem; border-radius: 4px; font-size: 0.8rem; white-space: pre-wrap; margin-top: 0.5rem; }
      `}</style>
    </div>
  );
}
